import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { RestApiServices } from '../providers/rest.service';
import { Router, NavigationStart } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { LanguageService } from '../providers/lang.service';
import { Input } from '@angular/core';
@Component({
  selector: 'app-search-products',
  templateUrl: './search-products.component.html',
  styleUrls: ['./search-products.component.css']
})
export class SearchProductsComponent implements OnInit {

  public flag: boolean = true;
  public ClientName = '';
  search = new BehaviorSubject<any>(0);
  searchValue = this.search.asObservable();
  public searchTerms = new Subject<string>();
  public clients:any;
  search_label: string = "";
  constructor(private restAPI: RestApiServices, public router: Router, private langService: LanguageService) { }

  ngOnInit() {
    this.langService.getJson().subscribe(data => {
      this.langService.getLangLabelValue("LblProductSearch").then(result => {
        this.search_label = result;

      });
      
    });

  }
  

  searchClient(term: string): void {
    this.flag = true;
    
    this.restAPI.changeSearchedProducts(term);
    this.ClientName = "";
    this.routeToSearch();
  }
  
  onselectClient(ClientObj) {
    if (ClientObj.item_number != 0) {
      this.ClientName = ClientObj.data;
      this.flag = false;
    }
    else {
      return false;
    }
    
   }
  // categorySelected(term){ 
   
  //   this.restAPI.getSearchedProducts(term);
  //   this.router.navigate(['dashboard/shop/searchproduct']);
  // }

  routeToSearch() {
    this.router.navigate(['dashboard/shop/searchproduct']);
  }

  routeToTopSelling() {
    this.router.navigate(["/dashboard/shop/topsales"]);
  }
}



// WEBPACK FOOTER //
// ./src/app/search-products/search-products.component.ts